import { UserService } from "@/app/core/apis/user.service";
import { IntercomSessionService } from "@/app/core/services/intercom-session.service";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import posthog from "posthog-js";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { of } from "rxjs";
import { loadCurrentUser, loadCurrentUserFailure, loadCurrentUserSuccess } from "./auth.actions";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private intercomSession: IntercomSessionService
  ) {}

  currentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCurrentUser),
      switchMap(() =>
        this.userService.me().pipe(
          tap((user) => posthog.identify(user.id, { email: user.email, name: `${user.firstName} ${user.lastName}` })),
          map((user) => loadCurrentUserSuccess({ user })),
          catchError((err) => of(loadCurrentUserFailure({ error: err?.message ?? "Unknown error" })))
        )
      )
    )
  );

  bootIntercom$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadCurrentUserSuccess),
        switchMap(({ user }) => this.intercomSession.boot(user))
      ),
    { dispatch: false }
  );
}
